<template>
    <div>
        <h3>404!</h3>
        <h4>La page demandée n'a pas pu être trouvée!</h4>
    </div>
</template>

<script>
export default {
    name: 'FourOhFour',
    props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
    font-size: 10em;
    text-align:center;
    color:red;
}
h4 {
    text-align:center;
}
</style>
